import { PHONE_DISPLAY, PHONE_NUMBER } from 'lib/constants';
import HorizontalLeadForm from './HorizontalLeadForm';

export default function HorizontalLeadFormSection() {
  return (
    <div className="bg-gray-100">
      <div className="max-w-5xl px-4 py-16 mx-auto text-center sm:py-20 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl">
          <span className="block">Get a FREE quote</span>
        </h2>
        <p className="mt-4 text-lg leading-6 text-gray-900">
          Call{' '}
          <a
            href={`tel:${PHONE_NUMBER}`}
            className="font-bold underline text-primary"
          >
            {PHONE_DISPLAY}
          </a>{' '}
          or fill out the form below and an EnergyPal advisor will call you,
          from time to time, about EnergyPal offers.
        </p>

        <HorizontalLeadForm />
      </div>
    </div>
  );
}
